export default {
  space: "iw9jwdswi70i",
  environment: "master",
  accessToken: "ucXlxvK4lGU2EZxensLftdkMXrI-xpxkSstQ1XBo73Y",
};
